import { PaymentMethodType } from '../../services/hpf-transaction-service';
import { PaymentFeeType } from './payment-fee-type';

export class CalculateFeeRequest {
	userType: string;
	merchantKeys: Array<number>;
	zipCode: string;
	convenienceFeeOverrideAmount: number | undefined;
	paymentMethodType: PaymentMethodType;
	amountUsedToCalculateSurchargeOnIfApplicable: number;
	paymentMethodKey: number | undefined;
	accountNumber: string | undefined;
	customerAccountKeys: number[] | undefined;
	paymentFeeType: PaymentFeeType | undefined;
}
